window.zESettings = {
    webWidget: {
        position: {
            horizontal: false,
            vertical: 'bottom'
        },
        offset: {
            horizontal: 0,
            vertical: 0
        },
        launcher: {
            suppress: true,
            labelVisible: true
        },
        color: {
            theme: '{{ settings.color_primary }}'
        },
        chat: {
            connectOnPageLoad: !1,
            departments: {
                enabled: ['Decathlon'],
                select: 'Decathlon'
            },
            concierge: {
                name: 'Decathlon',
                avatarPath: 'https://cdn.shopify.com/s/files/1/0468/8540/4839/t/2/assets/favicon-32x32.png?v=48199063949251108661608657568%22%20sizes=%2232x32%22',
                title: { '*': 'Live support' }
            }
        },
        contactForm: {
            suppress: false,
            ticketForms: [{ id: 360001278238 }]
        }, helpCenter: {
            suppress: true
        }, talk: {
            suppress: true
        }, answerBot: {
            suppress: true
        },
    }
};